import { FeedbackSummaryStoreContext } from './FeedbackSummaryStoreContext';

export const useFeedbackSummaryStore = FeedbackSummaryStoreContext.useStore;
